import { z } from "zod";

/** The Data Hub page's tabs, in display order. */
export const DATA_HUB_TABS = ["status", "rules", "sources"] as const;

export type DataHubTab = (typeof DATA_HUB_TABS)[number];

/**
 * Search parameters of the `/data-hub` route. An unknown tab falls back to the
 * Status tab rather than failing the route.
 */
export const dataHubSearchSchema = z.object({
  tab: z.enum(DATA_HUB_TABS).optional().catch(undefined),
});
